function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * @license Copyright (c) 2003-2021, CKSource - Frederico Knabben. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
 * @module alignment/alignmentediting
 */
import { Plugin } from 'ckeditor5/src/core';
import AlignmentCommand from './alignmentcommand';
import { isDefault, isSupported, normalizeAlignmentOptions, supportedOptions } from './utils';
/**
 * The alignment editing feature. It introduces the {@link module:alignment/alignmentcommand~AlignmentCommand command} and adds
 * the `alignment` attribute for block elements in the {@link module:engine/model/model~Model model}.
 * @extends module:core/plugin~Plugin
 */

var AlignmentEditing = /*#__PURE__*/function (_Plugin) {
  _inherits(AlignmentEditing, _Plugin);

  var _super = _createSuper(AlignmentEditing);

  /**
   * @inheritDoc
   */
  function AlignmentEditing(editor) {
    var _this;

    _classCallCheck(this, AlignmentEditing);

    _this = _super.call(this, editor);
    editor.config.define('alignment', {
      options: _toConsumableArray(supportedOptions.map(function (option) {
        return {
          name: option
        };
      }))
    });
    return _this;
  }
  /**
   * @inheritDoc
   */


  _createClass(AlignmentEditing, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var locale = editor.locale;
      var schema = editor.model.schema;
      var options = normalizeAlignmentOptions(editor.config.get('alignment.options')); // Filter out unsupported options and those that are redundant, e.g. `left` in LTR / `right` in RTL mode.

      var optionsToConvert = options.filter(function (option) {
        return isSupported(option.name) && !isDefault(option.name, locale);
      }); // Once there is at least one `className` defined, we switch to alignment with classes.

      var shouldUseClasses = optionsToConvert.some(function (option) {
        return !!option.className;
      }); // Allow alignment attribute on all blocks.

      schema.extend('$block', {
        allowAttributes: 'alignment'
      });
      editor.model.schema.setAttributeProperties('alignment', {
        isFormatting: true
      });

      if (shouldUseClasses) {
        editor.conversion.attributeToAttribute(buildClassDefinition(optionsToConvert));
      } else {
        // Downcast inline styles.
        editor.conversion.for('downcast').attributeToAttribute(buildDowncastInlineDefinition(optionsToConvert));
      }

      var upcastInlineDefinitions = buildUpcastInlineDefinitions(optionsToConvert); // Always upcast from inline styles.

      var _iterator = _createForOfIteratorHelper(upcastInlineDefinitions),
          _step;

      try {
        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          var definition = _step.value;
          editor.conversion.for('upcast').attributeToAttribute(definition);
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }

      var upcastCompatibilityDefinitions = buildUpcastCompatibilityDefinitions(optionsToConvert); // Always upcast from deprecated `align` attribute.

      var _iterator2 = _createForOfIteratorHelper(upcastCompatibilityDefinitions),
          _step2;

      try {
        for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
          var _definition = _step2.value;
          editor.conversion.for('upcast').attributeToAttribute(_definition);
        }
      } catch (err) {
        _iterator2.e(err);
      } finally {
        _iterator2.f();
      }

      editor.commands.add('alignment', new AlignmentCommand(editor));
    }
  }], [{
    key: "pluginName",
    get:
    /**
     * @inheritDoc
     */
    function get() {
      return 'AlignmentEditing';
    }
  }]);

  return AlignmentEditing;
}(Plugin); // Prepare downcast conversion definition for inline alignment styling.
// @private


export { AlignmentEditing as default };

function buildDowncastInlineDefinition(options) {
  var definition = {
    model: {
      key: 'alignment',
      values: options.map(function (option) {
        return option.name;
      })
    },
    view: {}
  };

  var _iterator3 = _createForOfIteratorHelper(options),
      _step3;

  try {
    for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
      var _ref2 = _step3.value;
      var name = _ref2.name;
      definition.view[name] = {
        key: 'style',
        value: {
          'text-align': name
        }
      };
    }
  } catch (err) {
    _iterator3.e(err);
  } finally {
    _iterator3.f();
  }

  return definition;
} // Prepare upcast definitions for inline alignment styles.
// @private


function buildUpcastInlineDefinitions(options) {
  var definitions = [];

  var _iterator4 = _createForOfIteratorHelper(options),
      _step4;

  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _ref4 = _step4.value;
      var name = _ref4.name;
      definitions.push({
        view: {
          key: 'style',
          value: {
            'text-align': name
          }
        },
        model: {
          key: 'alignment',
          value: name
        }
      });
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }

  return definitions;
} // Prepare upcast definitions for deprecated `align` attribute.
// @private


function buildUpcastCompatibilityDefinitions(options) {
  var definitions = [];

  var _iterator5 = _createForOfIteratorHelper(options),
      _step5;

  try {
    for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
      var _ref6 = _step5.value;
      var name = _ref6.name;
      definitions.push({
        view: {
          key: 'align',
          value: name
        },
        model: {
          key: 'alignment',
          value: name
        }
      });
    }
  } catch (err) {
    _iterator5.e(err);
  } finally {
    _iterator5.f();
  }

  return definitions;
} // Prepare conversion definitions for upcast and downcast alignment with classes.
// @private


function buildClassDefinition(options) {
  var definition = {
    model: {
      key: 'alignment',
      values: options.map(function (option) {
        return option.name;
      })
    },
    view: {}
  };

  var _iterator6 = _createForOfIteratorHelper(options),
      _step6;

  try {
    for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
      var option = _step6.value;
      definition.view[option.name] = {
        key: 'class',
        value: option.className
      };
    }
  } catch (err) {
    _iterator6.e(err);
  } finally {
    _iterator6.f();
  }

  return definition;
}
/**
 * The alignment configuration format descriptor.
 *
 *		const alignmentFormat = {
 *			name: 'right',
 *			className: 'my-align-right-class'
 *		}
 *
 * @typedef {Object} module:alignment/alignmentediting~AlignmentFormat
 *
 * @property {'left'|'right'|'center'|'justify'} name One of the alignment names options.
 *
 * @property {String} className The CSS class used to represent the style in the view.
 * Used to override default, inline styling for alignment.
 */